import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Generator from "@/pages/Generator";
import FormBuilder from "@/pages/FormBuilder";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import InviteAccept from "@/pages/InviteAccept";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ResetTwoFA from "@/pages/ResetTwoFA";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-2fa" element={<ResetTwoFA />} />
            <Route path="/" element={<ProtectedRoute><Generator /></ProtectedRoute>} />
            <Route path="/forms" element={<ProtectedRoute><FormBuilder /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
